// src/utils/passwordValidation.ts — Validador de fortaleza de contraseña alineado con backend
export interface PasswordValidationResult {
  ok: boolean
  msg?: string
}

export function validatePasswordStrength(pwd: string): PasswordValidationResult {
  if (pwd.length < 8) {
    return { ok: false, msg: 'La contraseña debe tener al menos 8 caracteres.' }
  }
  if (!/[A-Z]/.test(pwd)) {
    return { ok: false, msg: 'Debe contener al menos una letra mayúscula.' }
  }
  if (!/[a-z]/.test(pwd)) {
    return { ok: false, msg: 'Debe contener al menos una letra minúscula.' }
  }
  if (!/\d/.test(pwd)) {
    return { ok: false, msg: 'Debe contener al menos un número.' }
  }
  if (!/[^A-Za-z0-9]/.test(pwd)) {
    return { ok: false, msg: 'Debe contener al menos un carácter especial (ej. @, !, $, *, &).' }
  }
  return { ok: true }
}
